import KnowledgeCenter from './learn'

export default KnowledgeCenter
